import apiService from './apiService'

export default {
  async get () {
    const response = await apiService.get('api/settings/action-button')
    return response.data
  },

  async update (settings) {
    const response = await apiService.put('api/settings/action-button', settings)
    return response.data
  }
}



// WEBPACK FOOTER //
// ./src/services/actionButtonSettingsService.js